import { Injectable, Injector, Type } from '@angular/core';

import * as ConfigActions from '@dav-store/config/config.actions';
import * as fromRoot from '@dav-store/reducers';
import { Store } from '@ngrx/store';
import { OktaAuth } from '@okta/okta-auth-js';

import { OktaService } from './okta.service';

@Injectable({
  providedIn: 'root',
})
export class LazyOktaService {
  private _oktaService: OktaService | undefined;

  constructor(private injector: Injector, private store$: Store<fromRoot.State>) {}

  async getOktaAuth(): Promise<OktaAuth> {
    const service = await this._initOktaService();

    return service.getOktaAuth();
  }

  async getOktaWidget() {
    const service = await this._initOktaService();

    return service.getOktaWidget();
  }

  async oktaSignOut() {
    const service = await this._initOktaService();

    return service.oktaSignOut();
  }

  private async get<T>(providerLoader: () => Promise<Type<T>>): Promise<T> {
    const token = await providerLoader();
    return this.injector.get(token);
  }

  private async _initOktaService(): Promise<OktaService> {
    if (!this._oktaService) {
      this.store$.dispatch(new ConfigActions.SetOktaLoadingAction());
      this._oktaService = await this.get(() => import('./okta.service').then((m) => m.OktaService));
      this.store$.dispatch(new ConfigActions.ResetOktaLoadingAction());
    }

    return this._oktaService;
  }
}
